import { REALM } from "./index";

// Browser tab title + favicon — index.html itself is static (plain CRA, no per-realm HTML
// templating), so these are swapped here at runtime instead, the same "REALM picks the asset"
// approach as every other per-brand resource in this folder. Only NiksFit has its own icon set
// so far (public/favicon*-niksfit.*, apple-touch-icon-niksfit.png) — HitFit's existing
// index.html tags are left completely untouched when REALM isn't "niksfit".
export function applyBrandHead() {
  if (REALM !== "niksfit") return;

  document.title = "Niksfit";

  document
    .querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]')
    .forEach((link) => {
      const href = link.getAttribute("href");
      if (!href || href.includes("-niksfit.")) return;
      const niksfitHref = href.replace(/(\.[^./]+)$/, "-niksfit$1");
      link.setAttribute("href", niksfitHref);
    });

  // iOS "Add to Home Screen" reads apple-mobile-web-app-title straight off the live page (not
  // manifest.json — see index.html's own comment on that), same for Android/Chrome's
  // application-name.
  document
    .querySelectorAll(
      'meta[name="apple-mobile-web-app-title"], meta[name="application-name"]'
    )
    .forEach((meta) => {
      meta.setAttribute("content", "Niksfit Office");
    });

  // Android/Chrome's own "Add to Home Screen" install prompt reads name/short_name/icons from
  // the Web App Manifest instead (the meta tags above don't cover it) — manifest-niksfit.json
  // is NiksFit's own copy of manifest.json (own name + own icons/favicon-niksfit.ico,
  // android-chrome-*-niksfit.png), swapped in the same way as the favicon links above.
  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink) {
    const href = manifestLink.getAttribute("href");
    if (href && !href.includes("-niksfit.")) {
      manifestLink.setAttribute("href", href.replace(/(\.[^./]+)$/, "-niksfit$1"));
    }
  }
}
